@if (!hasSelectedCourse) {
  <div
    class="relative rounded-xl p-2"
    [ngClass]="{ 'bg-[#c91d1d1a]': errorMessage }"
  >
    <div
      tabindex="0"
      class="flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-dashed p-[1.6rem]"
      [ngClass]="{
        'border-grey': !errorMessage,
        'border-cancel bg-grey-lightGrey': errorMessage,
      }"
      (click)="handleCourseSelection()"
      (keydown.enter)="handleCourseSelection()"
      (keydown.space)="handleCourseSelection()"
    >
      <mat-icon class="material-icons-outlined hvs-icon-lg !text-blue">
        add
      </mat-icon>
      <span class="whitespace-pre text-sm font-semibold text-blue">
        {{ label }}
      </span>
    </div>
  </div>
} @else {
  <app-course-card
    *transloco="let t"
    [name]="control.value!.name"
    [courseId]="control.value!.id"
    [isEditable]="isEditable"
    (removeCourseButtonClickedEvent)="handleRemoveCourse()"
  />
}
